import React from 'react';
import { MapPin } from 'lucide-react';
import { mockData } from '../mock';

export const About = () => {
  const { about } = mockData;

  return (
    <section id="about" className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 md:mb-8 tracking-tight">
          {about.title}
        </h2>
        <p className="text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-6 md:mb-8">
          {about.description}
        </p>
        
        <div className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-full shadow-sm border border-gray-100">
          <MapPin className="text-[#2AD7C5]" size={20} />
          <span className="text-gray-700 font-medium">UAE</span>
        </div>
      </div>
    </section>
  );
};
